import theme from '@/theme';
import { Box } from '@montugroup/design-system/Layout';
import { Link } from '@montugroup/design-system/Link';
import { useWaitingRoomTracking } from './useWaitingRoomTracking';

type WaitingRoomNotificationProps = {
  calendarUrl: string;
  consultationId: number;
};

export const WaitingRoomNotificationLink: React.FC<WaitingRoomNotificationProps> = ({
  calendarUrl,
  consultationId,
}) => {
  const { trackWaitingRoomNotificationClick } = useWaitingRoomTracking();
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      <Link
        sx={{ color: theme.palette.info.main }}
        href={calendarUrl}
        onClick={() => trackWaitingRoomNotificationClick(consultationId)}
      >
        Go to Calendar
      </Link>
    </Box>
  );
};
